import React, { useState } from 'react'
import { useForm } from 'react-hook-form'
import { useMutation } from 'react-query'

import { Box, Button, Input, Modal, Select, showToast, Title } from '@superlogica/design-system'
import { alterarStatus} from 'services/contratos/contrato/atualizarStatus'

const View = ({ uuId, status, refreshStatus }) => {
  const { register, handleSubmit, reset } = useForm()
  const [selectValue, setSelectValue] = useState('2', 'Ativo')
  const [selectValue2, setSelectValue2] = useState('Potência Mínima')
  const [isVisible, setisVisible] = useState(false)
  const [isVisible2, setisVisible2] = useState(false)
  const [isOpen, setIsOpen] = useState(false)
  const openModalStatus = () => setIsOpen(true)
  const closeModalStatus = () => setIsOpen(false)

  const optionsStatus = populateOptionsStatus(status)

  const optionsMotivo = [
    { value: 'Potência Mínima', name: 'Potência Mínima' },
    { value: 'Já possui contrato de GD', name: 'Já possui contrato de GD' },
    { value: 'Sem conta anexada e ou Termos não aceito', name: 'Sem conta anexada e ou Termos não aceito' },
    { value: 'Cliente com subsídio', name: 'Cliente com subsídio' },
    { value: 'Inadimplente', name: 'Inadimplente' },
    { value: 'Titularidade divergente', name: 'Titularidade divergente' }
  ]

  const optionsMotivoCanc = [
    { value: 'Insatisfação com o prazo de entrega do benefício', name: 'Insatisfação com o prazo de entrega do benefício' },
    { value: 'Contratei outra Empresa GD ', name: 'Contratei outra Empresa GD ' },
    { value: 'Mudança de residência', name: 'Mudança de residência' },
    { value: 'Insatisfação com o atendimento ao cliente ', name: 'Insatisfação com o atendimento ao cliente ' },
    { value: 'Expectativas não atendidas', name: 'Expectativas não atendidas' },
    { value: 'Outro motivo', name: 'Outro motivo' },
    { value: 'Desistência', name: 'Desistência' }
  ]


  function populateOptionsStatus(status) {
    return status.map((item) => ({
      name: item.nome,
      value: item.id
    }))
  }
  function handleChange(e) {
    setSelectValue(e.target.value, e.target.name)
    if(e.target.value === "12" ){
      setisVisible(true)  
    }else{
      setisVisible(false)  
    }

    if(e.target.value === "2"){
      setisVisible2(true)
    }else{
      setisVisible2(false)  
    }


  }

  function handleChange2(e) {
    setSelectValue2(e.target.value)
  }


  const atualizarStatusMutation = useMutation(alterarStatus)
  function atualizarStatus(data) {
    atualizarStatusMutation.mutate(data, {
      onSuccess: () => {
        refreshStatus()
        showToast({
          type: 'success',
          message: 'Status alterado com sucesso'
        })
        closeModalStatus()
        reset({})
      }
    })
  }

  return (
    <>
      <Button appearance="outline" size="sm" className="ml-auto" onClick={openModalStatus}>
        Editar status contrato
      </Button>
      <Modal
        isOpen={isOpen}
        onRequestClose={closeModalStatus}
        width={800}
        label="Testando modal"
      >
        <form onSubmit={handleSubmit(atualizarStatus)}>
          <input type="hidden" name="id" value={uuId} {...register('id')} />
          <Box
            paddingType="square"
            paddingSize="sm"
            border="xs"
            borderColor="neutral100"
            style={{ borderBottom: 'none' }}
          >
            <Title size="body01" weight="bold" color="neutral800">
              Editar Status do Contrato
            </Title>
          </Box>
          <Box paddingType="square" paddingSize="sm" border="xs" borderColor="neutral100">
            <Box>
              <Select
                size="sm"
                label="Selecione uma opção de status"
                name="Teste"
                value={selectValue}
                {...register('id_contratoStatus')}
                onChange={handleChange}
                options={optionsStatus}
              />
            </Box>
            {isVisible ? 
            <Box>
              <Select
                size="sm"
                label="Selecione uma opção do motivo"
                name="Teste"
                value={selectValue2}
                {...register('status_descricao')}
                onChange={handleChange2}
                options={optionsMotivo}
              />
            </Box> : ""}
            {isVisible2 ? 
            
            <Box>
                <Select
                size="sm"
                label="Selecione uma opção do motivo"
                name="Teste"
                className="mb-md"
                value={selectValue2}
                {...register('status_descricao')}
                onChange={handleChange2}
                options={optionsMotivoCanc}
              />
              <Input
                size="sm"
                label="Descreva"
                {...register('status_descricao_cancelamento')}
              />
            </Box> : ""}
          </Box>
         
          <Box
            paddingType="squish"
            paddingSize="sm"
            border="xs"
            borderColor="neutral100"
            style={{ display: 'flex', borderTop: 'none' }}
          >
            <Button
              className="mr-auto"
              color="primary"
              appearance="ghost"
              onClick={closeModalStatus}
            >
              Cancelar
            </Button>

            <Button className="ml-auto">Salvar</Button>
          </Box>
        </form>
      </Modal>
    </>
  )
}

export default View
